import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  TextField,
} from "@mui/material";
import useResendTwoFactor from "./hooks/useResendTwoFactor";
import useEnterTwoFactor from "./hooks/useEnterTwoFactor";
import { useState } from "react";
import { LoadingButton } from "@/ui/LoadingButton";

type Props = {
  onCompleted?: () => void;
};

export default function TwoFactorForm({ onCompleted }: Props) {
  const { isSending, isError, handleResend } = useResendTwoFactor();
  const {
    isEntering,
    isError: isEnterError,
    handleEnter,
  } = useEnterTwoFactor({ onCompleted });
  const [code, setCode] = useState("");
  return (
    <Card
      elevation={2}
      sx={{
        p: 1,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: 436,
        maxWidth: "100%",
      }}
      data-testid="twofactor-form"
    >
      <CardHeader title="Verify it's you" />
      <CardContent sx={{ gap: 2, display: "flex", flexDirection: "column" }}>
        <Typography variant="body1" color="text.secondary">
          Enter the code we sent to your email.
        </Typography>
        <TextField
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Enter 6 digit code"
          data-testid="twofactor-code-input"
        />
        {isError || isEnterError ? (
          <Typography
            variant="body2"
            color="error"
            data-testid="twofactor-error-message"
          >
            {isError ? "Something went wrong." : "Code is invalid."}
          </Typography>
        ) : null}
        <LoadingButton
          loading={isEntering}
          disabled={isSending || isEntering}
          variant="contained"
          onClick={() => handleEnter(code)}
          data-testid="twofactor-submit-button"
        >
          Verify
        </LoadingButton>
        <LoadingButton
          loading={isSending}
          disabled={isSending || isEntering}
          variant="text"
          onClick={handleResend}
        >
          Resend code
        </LoadingButton>
      </CardContent>
    </Card>
  );
}
